<template>
  <BaseDialog contentClass="edit-go-nogo-reason" ref="dialog" sidePanel :show-actions="true" @closeModal="closeDialog">
    <template #title>
      {{ dialogTitle }}
    </template>
    <template #content>
      <form @submit.prevent="onSubmit" class="edit-go-nogo-reason__form" @keydown.enter="handleEnterPress">
        <div class="form-section">
          <BaseSelect
            :label="$t('page.admin-go-nogo.vote')"
            name="voteType"
            :value="voteType"
            :items="voteOptions"
            item-text="text"
            item-value="value"
            is-required
            @change="onVoteTypeChange"
          />
        </div>
        <div class="form-section">
          <FormInput
            ref="reason"
            :label="$t('page.admin-go-nogo.reason')"
            is-required
            has-gray-background
            name="reason"
            type="text"
            v-model="reason"
            v-validate="'required'"
          />
        </div>
        <div class="edit-go-nogo-reason__actions">
          <FormButton is-outlined class="edit-go-nogo-reason__cancel" @click.native="cancelClick">
            {{ $t('actions.cancel') }}
          </FormButton>
          <FormButton type="submit" :disabled="isFormInvalid">
            <span>{{ buttonText }}</span>
          </FormButton>
        </div>
      </form>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog';
import FormButton from '@/components/form/FormButton';
import FormInput from '@/components/form/FormInput.vue';
import BaseSelect from '../base/BaseSelect.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'EditGoNoGoReasonDialog',
  components: {
    BaseDialog,
    FormButton,
    FormInput,
    BaseSelect,
  },
  data() {
    return {
      existingItem: null,
      voteType: '',
      reason: '',
    };
  },
  computed: {
    ...mapGetters('goNoGo', ['opportunityVoteReasons']),
    voteOptions() {
      return [
        { text: 'Go', value: 'YES' },
        { text: 'No Go', value: 'NO' },
      ];
    },
    dialogTitle() {
      return this.existingItem && this.existingItem.voteType
        ? this.$t('page.admin-go-nogo.edit-item-dialog')
        : this.$t('page.admin-go-nogo.add-item-dialog');
    },
    buttonText() {
      return this.existingItem && this.existingItem.voteType ? this.$t('actions.save') : this.$t('actions.add');
    },
    isFormInvalid() {
      return !this.voteType || !this.reason;
    },
    isDuplicate() {
      const existingReason = this.opportunityVoteReasons.find(
        (item) => item.voteType === this.voteType && item.reason.toLowerCase() === this.reason.toLowerCase(),
      );
      return existingReason && (!this.existingItem || existingReason.id !== this.existingItem.id);
    },
  },
  methods: {
    ...mapActions('goNoGo', ['addOpportunityVoteReason', 'updateOpportunityVoteReason']),
    openDialog(item) {
      this.existingItem = item;
      this.voteType = item.voteType;
      this.reason = item.reason;
      this.$refs.dialog.openModal();
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },
    onSubmit() {
      if (!this.$refs.dialog.isModalOpen) return;
      if (this.isFormInvalid) {
        this.$toast.error(this.$t('errors.missingFields'));
        return;
      }

      if (this.isDuplicate) {
        this.$toast.show(this.$t('page.admin-go-nogo.actions.duplicate'), 'error');
        return;
      }
      if (this.existingItem && this.existingItem.id) {
        this.updateOpportunityVoteReason({
          id: this.existingItem.id,
          voteType: this.voteType,
          reason: this.reason,
        })
          .then(() => {
            this.$toast.success(this.$t('page.admin-go-nogo.actions.success-update'));
            this.$emit('action-succeeded');
            this.closeDialog();
          })
          .catch((error) => {
            this.$toast.error(error);
          });
      } else {
        this.addOpportunityVoteReason({
          voteType: this.voteType,
          reason: this.reason,
        })
          .then(() => {
            this.$toast.success(this.$t('page.admin-go-nogo.actions.success-add'));
            this.$emit('action-succeeded');
            this.closeDialog();
          })
          .catch((error) => {
            this.$toast.error(error);
          });
      }
    },
    cancelClick() {
      this.closeDialog();
    },
    onVoteTypeChange(voteType) {
      this.voteType = voteType;
    },
    handleEnterPress(event) {
      if (this.isFormInvalid) {
        event.preventDefault();
      } else {
        this.onSubmit();
      }
    },
  },
};
</script>

<style lang="scss">
.edit-go-nogo-reason__form {
  .form-input {
    padding-bottom: 16px;
  }
  .edit-go-nogo-reason__actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 32px;
  }
  .edit-go-nogo-reason__cancel {
    margin-right: 12px;
  }
}
.base-dialog__edit-go-nogo-reason {
  .base-dialog__content {
    padding: 32px;
    background: $color-white !important;
  }
}
</style>
